const TraitScoreBar = ({ color, score }) => {
  const width = (1 - Math.pow((score - 0.01) / 100, 0.35)) * 100 + '%' // exponential curve, ^0.35 for less linearity and visual differentiation for top heavy score values near 100%

  return (
    <div className="relative h-3 w-[233px] skew-x-[15deg] pl-4" title={`Rarity: ${score}%`}>
      <div className="absolute z-[1] h-full w-full opacity-20" style={{ background: color }} />
      <div className="absolute z-[3] h-full" style={{ background: color, width: width }} />
      <div className="absolute bottom-0 z-[2] h-1 w-full opacity-20 backdrop-blur-2xl" style={{ background: color }} />
    </div>
  )
}

export default TraitScoreBar
